import { render } from "./DeletedUsersList.vue?vue&type=template&id=5771e179&scoped=true"
import script from "./DeletedUsersList.vue?vue&type=script&lang=js"
export * from "./DeletedUsersList.vue?vue&type=script&lang=js"

import "./DeletedUsersList.vue?vue&type=style&index=0&id=5771e179&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5771e179"]])

export default __exports__